<template>
    <div>
        <aside-content-header with-date-picker :vehicle="currentJourney.vehicle" :is-hardware-online="isHardwareOnline"></aside-content-header>
        <div class="journey-list">
            <div v-if="getJourneys.length > 0">
                <journey v-for="(journey, index) in getJourneys" :key="journey.id" :journey="journey" :index="index" class="journey-list__item"></journey>
            </div>
            <plug v-else icon="map-regular" title="No journeys have been found" :width="45" :height="55" color="#e2e2e2"></plug>
        </div>
    </div>
</template>

<script>
import TrackingService from '@/services/TrackingService'
import Journey from './JourneyItem/Journey'
import Journeys from '@/models/Journeys'
import AsideContentHeader from '@/views/Tracking/components/Aside/AsideContentHeader/AsideContentHeader'
import Plug from '@/components/atoms/Plug'

export default {
    name: 'JourneyList',
    components: {
        Journey,
        AsideContentHeader,
        Plug
    },
    props: {
        currentJourney: {
            type: [Journeys, null],
            required: false
        },
        isHardwareOnline: {
            type: [Boolean],
            required: true
        }
    },
    computed: {
        getJourneys () {
            return TrackingService.getJourneyListToDisplay(this.currentJourney)
        }
    }
}
</script>

<style scoped lang="scss">
.journey-list {

    &__item {
        margin-bottom: 20px;
    }
}

::v-deep .mx-datepicker {
    input {
        height: 38px;
    }
}
</style>
